let funcLogout = null
let downloadFunc = null
export function setFuncLogout(func) {
    funcLogout = func
}
export function logout() {
    funcLogout && funcLogout()
}

export function setDownloadSampleFuc(func) {
    downloadFunc = func;
}
export function downloadSample() {
    downloadFunc && downloadFunc()
}



// WEBPACK FOOTER //
// ./src/utils/globalFunc.js